var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
var Redirector = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get commonAttrs() {
            return {
                className: "Redirector",
                href: p.url,
                title: p.title,
                target: p.openInNewTab ? "_blank" : undefined,
                rel: p.openInNewTab ? "noreferrer" : undefined,
            };
        }
    }); });
    return React.createElement(Observer, { children: function () { return (p.shouldRedirect
            ? React.createElement("a", __assign({}, s.commonAttrs), props.children)
            : React.createElement(React.Fragment, null, props.children)); } });
};
export default Redirector;
